import PropTypes from 'prop-types';

import LanguageSelector from './LanguageSelector';

const PaidModalBody = ({
  selectedIndex,
  setSelectedIndex,
  courseEnabledLanguages,
  originalCourseLanguage,
}) => (
  <LanguageSelector
    {...{
      selectedIndex,
      setSelectedIndex,
      courseEnabledLanguages,
      originalCourseLanguage,
    }}
  />
);

PaidModalBody.propTypes = {
  courseEnabledLanguages: PropTypes.arrayOf(
    PropTypes.shape({
      code: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectedIndex: PropTypes.number.isRequired,
  setSelectedIndex: PropTypes.func.isRequired,
  originalCourseLanguage: PropTypes.string.isRequired,
};

export default PaidModalBody;
